import { Button, FormControl, FormHelperText, FormLabel, Icon, Select, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { AuthorityActivity, useUpdateOrganizationMutation } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../../common/errors/useApiError";
import { useAppDispatch } from "../../../../common/redux/hooks";
import { updateSelectedOrg } from "../../../../common/redux/reducers/authStateReducer";

interface FormValues {
  authorityActivity: AuthorityActivity | "";
}

interface Props {
  currentValue: AuthorityActivity | null;
}

export const ChangeAuthorityActivity = ({ currentValue }: Props) => {
  const authState = useLoggedInWithOrgContextState();
  const [editOrg, { isLoading }] = useUpdateOrganizationMutation();
  const toast = useToast();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const displayer = useApiError();
  const { register, handleSubmit, watch } = useForm<FormValues>({
    defaultValues: { authorityActivity: currentValue ?? "" },
  });

  const selected = watch("authorityActivity");

  const onSubmit = async (values: FormValues) => {
    const result = await editOrg({
      orgId: authState.selectedOrg.id,
      editOrganizationRequest: { authorityActivity: { value: values.authorityActivity || null } },
    });
    if ("data" in result) {
      dispatch(updateSelectedOrg(result.data));
      toast({ title: t("Main activity has been updated!"), status: "success" });
    } else {
      displayer.trigger(result.error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl id="authorityActivity" mt="20px">
        <FormLabel>{t("Main activity")}</FormLabel>
        <Select placeholder={t("Select your main activity") ?? ""} {...register("authorityActivity")}>
          {Object.values(AuthorityActivity).map((activity) => (
            <option key={activity} value={activity}>
              {t(activity)}
            </option>
          ))}
        </Select>
        <FormHelperText>
          {t(
            "Stated on your notices on Doffin. Without a choice, the notices say general public services",
          )}
        </FormHelperText>
      </FormControl>
      {(currentValue ?? "") !== selected && (
        <Button
          mt="10px"
          leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
          variant="solid"
          colorScheme="teal"
          size="sm"
          type="submit"
          isLoading={isLoading}
        >
          {t("Save change")}
        </Button>
      )}
    </form>
  );
};
